import { request } from '@/lib';
import { UiToast } from '@/components';

import partyRoom from '../../lib/room';
import gamesFightStore from './store';

const fetchGamesFightInfo = () =>
  request.funny
    .get('api/v1/multiRoom/war/data', {
      roomId: partyRoom.getRoomId(),
      showRankItem: 1,
    })
    .then((source: any) => {
      gamesFightStore.store.setInfo(source.data);
    });

const checkFightStatus = (target?: number) => {
  const params: any = {
    roomId: partyRoom.getRoomId(),
  };
  if (target) {
    params.target = target;
  }
  return request.funny
    .get('api/v1/multiRoom/war/inviteCheck', params)
    .catch((err) => {
      UiToast.fail(err.msg || '暂无法发起厅战');
      return Promise.reject(err);
    });
};

const gamesFightUtils = {
  fetchGamesFightInfo,
  checkFightStatus,
};

export default gamesFightUtils;
